export interface CurrencyInfo {
  code: string;
  name: string;
  symbol: string;
  flag: string;
  rateToUSD: number; // how many units of this currency = 1 USD
}

// Realistic exchange rates as of April 2026
export const currencies: CurrencyInfo[] = [
  { code: "USD", name: "US Dollar", symbol: "$", flag: "🇺🇸", rateToUSD: 1 },
  { code: "EUR", name: "Euro", symbol: "€", flag: "🇪🇺", rateToUSD: 0.9185 },
  { code: "GBP", name: "British Pound", symbol: "£", flag: "🇬🇧", rateToUSD: 0.7892 },
  { code: "RUB", name: "Russian Ruble", symbol: "₽", flag: "🇷🇺", rateToUSD: 96.5 },
  { code: "THB", name: "Thai Baht", symbol: "฿", flag: "🇹🇭", rateToUSD: 35.82 },
  { code: "TRY", name: "Turkish Lira", symbol: "₺", flag: "🇹🇷", rateToUSD: 38.45 },
];

// Cross-rate: convert `amount` of `fromCode` → `toCode`
export function convert(
  amount: number,
  fromCode: string,
  toCode: string
): number {
  const from = currencies.find((c) => c.code === fromCode);
  const to = currencies.find((c) => c.code === toCode);
  if (!from || !to) return 0;
  // from → USD → to
  const usdAmount = amount / from.rateToUSD;
  return usdAmount * to.rateToUSD;
}

export function getLastUpdated(): string {
  return "Apr 11, 2026 · 14:32 UTC";
}
